// Polyfill imports - need to be added at entry point for webpack
// to bundle these correctly.
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@cloudscape-design/global-styles/index.css'

// Must be the first non-polyfill import. On a regional app.justwalkout.com host this normalizes
// ?domain=/?region= from the hostname before any later import reads location.search -- see the
// comment in that module for why running this from _init instead was too late.
import '@src/bootstrap/normalizeLandingUrl'

import { HashRouter } from 'react-router-dom'

// Required for coral service Client api call
import('@amzn/ihm-coral-config/coral')

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { MbmProvider } from '@amzn/react-arb-tools'
import { Orchestrator } from '@src/orchestration/manager'
import App from '@src/App'
import { store } from '@atredux/store'
import ErrorBoundary from '@components/ErrorBoundary'
import arbManifest from '@src/i18n/translations/arbManifest'
import { resolveSessionLocale } from '@src/i18n/localeSession'
import translations from '@src/i18n/translations'
import { getMbmOptions, applyDocumentLocale } from '@amzn/jwo-store-management-platform-components'
// Do not import plan.ts!

const ROOT_ELEMENT_ID = 'app'

export const _init = async (): Promise<boolean> => {
    // Publish the session locale to <html lang> before anything renders.
    // getMbmOptions() reads that attribute to choose the initial message bundle,
    // so this must run ahead of _renderAssociateToolsBase or every session would
    // start in the default locale regardless of the ?locale= param.
    applyDocumentLocale(resolveSessionLocale())

    // Handle OAuth popup callback before rendering the app.
    // If this page was opened by the OAuth popup flow, exchange the code
    // for tokens and close the window — don't render the full app.
    const params = new URLSearchParams(window.location.search)
    if (params.get('code') && params.get('state')) {
        try {
            const { handleOAuthCallback } = await import('@services/auth/web/OAuthPopupService')
            const handled = await handleOAuthCallback()
            if (handled) return true
        } catch (err) {
            console.error('[init] OAuth callback failed:', err)
            return true // still prevent full app from rendering in the popup
        }
    }

    console.log('ATBase: Initializing App')
    Orchestrator.init()
    return false
}

export const _renderAssociateToolsBase = (): void => {
    return ReactDOM.render(
        <MbmProvider {...getMbmOptions(arbManifest, translations)}>
            <Provider store={store}>
                <ErrorBoundary key="rootBoundary">
                    <HashRouter>
                        <App />
                    </HashRouter>
                </ErrorBoundary>
            </Provider>
        </MbmProvider>,
        document.getElementById(ROOT_ELEMENT_ID),
    )
}

_init()
    .catch((err) => {
        console.error('[init] Unexpected error:', err)
        return false
    })
    .then((callbackHandled) => {
        if (!callbackHandled) {
            _renderAssociateToolsBase()
        }
    })
